import React, { useContext } from "react";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { ModuleContext } from "../utils/Constants";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";

export default function SaitButton(props) {
	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === props.objmod);

	return isComponentVisible(objMod, props.hidden) ? (
		<Button
			{...props}
			variant={props.variant || "contained"}
			color={props.color || "primary"}
			disabled={isComponentDisabled(objMod, props.disabled) || false}
			sx={props.sx || {}}
			loadingPosition={props.startIcon ? "start" : props.endIcon ? "end" : "center"}
		>
			<span>{props.text}</span>
			{props.icon}
			{props.children}
		</Button>
	) : null;
}
